<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
<!--  需要向full-page-shell组件传递backgroundImage,背景图片-->
  <full-page-shell
    class="regist-page-el-outer"
    :class="{registSuccess: isSubmitSuccess == true}"
  >
    <regist-form
      v-if="!isSubmitSuccess"
      @regist-success="registSuccess"
    ></regist-form>
    <submit-success
      v-if="isSubmitSuccess"
    ></submit-success>
    <vs-divider/>
    <div class="site-info display-flex justify-center">
      <span>COPYRIGHT &copy; {{ thisYear }}</span>
      <!--{{config.siteName}}-->
    </div>
  </full-page-shell>
</template>

<script>
import submitSuccess from "@/components/register/submitSuccess";
import registForm from "@/components/register/registForm";
import fullPageShell from "@/components/public/fullPageShell";
export default{
  components:{
    fullPageShell,
    registForm,
    submitSuccess,
  },
  data() {
    return {
      isSubmitSuccess: false,
    }
  },
  created(){
  },
  computed: {
    thisYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    registSuccess(){
      this.isSubmitSuccess = true;
    }
  },
}
</script>
<style lang="scss">
@media screen and (min-width: 768px){
  .regist-page-el-outer {
    &.registSuccess {
      .scroll-VuePerfectScrollbar {
        .right-real-content {
          padding-top: 240px;
        }
      }
    }
  }
}

@media screen and (max-width: 768px){
  .regist-page-el-outer {
    &.registSuccess {
      .scroll-VuePerfectScrollbar {
        .right-real-content {
          padding-top: 100px;
        }
      }
    }
  }
}
</style>
